import ApiClient from '@shoflo/api.v2-client';
import guid from 'shared/lib/uuid';
const clientId = guid();

let _apiClient;

export default () => {
  const { hostname, protocol, port } = window.location;

  if (_apiClient) return _apiClient;

  _apiClient = new ApiClient({
    endpoint: `${protocol}//${hostname}:${port}`,
    proxy: true,
    clientId,
  });

  return _apiClient;
};

export const getClientId = () => clientId;
